import {Component, Inject, Input, OnInit} from 'ng-metadata/core';
import {UnionCatalogLoginService} from './unionCatalogLogin.service';
import {LoginService} from "../login.service";
import {DirectLoginService} from "./directLogin.service";

@Component({
    selector: 'prm-union-catalog-login',
    templateUrl: 'components/security/login/unionCatalogLogin/union-catalog-login.html',
})

export class PrmUnionCatalogLogin implements OnInit{
    private readonly _unionCatalogInstitutionsList;
    private  _directLoginList;

    @Input() private state: object;

    constructor(private unionCatalogLoginService : UnionCatalogLoginService,
                private loginService : LoginService,
                private directLoginService: DirectLoginService,
                @Inject('$mdDialog') private $mdDialog: ng.material.IDialogService,
                @Inject('loginIcons') public loginIcons) {
        this._unionCatalogInstitutionsList = this.unionCatalogLoginService.getMemberInstitutionList();
        this.directLoginService.getDirectLinksList(this.state).then((directLoginList) => {
            this._directLoginList = directLoginList;
        });
    }

    ngOnInit() {
    }

    get unionCatalogInstitutionsList(){
        return this._unionCatalogInstitutionsList;
    }

    get directLoginList() {
        return this._directLoginList;
    }

    goToInstitutionLogin(institutionDetails){
        this.unionCatalogLoginService.goToInstitutionLogin(institutionDetails,this.state)
    }

    public cancelLogin() {
        this.loginService.removeBackgroundDarkClass();
        this.loginService.clearSavedState();
        this.$mdDialog.cancel();
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/components/security/login/unionCatalogLogin/unionCatalogLogin.directive.ts